import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { RouteError } from '@pa/staff'
import type { RouterContext } from '@/app/router'

// Composition only (Frontend §1.2). The guards sit on `_authed`; the A- screens are public routes. Any error while a
// route loads shows the shared error card (Frontend §3.5), never TanStack Router's raw default.
export const Route = createRootRouteWithContext<RouterContext>()({
  component: Outlet,
  errorComponent: RouteError,
})
